import { useEffect } from "react";

const useClickOutside = (ref, callback = () => {}) => {
  const handleClickOutside = (event) => {
    if (ref.current && ref.current.contains(event.target)) {
      return;
    }
    const clickedElement = event.target;
    const isUpdateButton =
      clickedElement.closest("button")?.textContent?.includes("Update Event") ||
      clickedElement.closest("button")?.textContent?.includes("save Event");

    if (ref.current && !ref.current.contains(event.target) && !isUpdateButton) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};

export default useClickOutside;
